import * as R from 'ramda'

/**
 * Takes an expense with an array of receipts and a new receipt, and updates the
 * receipt with the required fields
 *
 * @param {object} expense The expense around which a receipt is going to be
 *   updated.
 * @param {object} newReceipt The updated receipt meant to replace an existing
 *   receipt
 * @returns Expense - returns an expense with the updated receipt
 */

export const updateExpenseReceipts = (expense = {}, newReceipt = {}) => {
  const currentReceipts = R.propOr([], 'documents', expense)

  const updatedReceipts = currentReceipts.map((receipt = {}) => {
    return receipt.uuid === newReceipt.uuid
      ? { ...receipt, locked: newReceipt.locked, name: newReceipt.name }
      : receipt
  })
  return { ...expense, documents: updatedReceipts }
}

/**
 * Takes an expense with an array of receipts and a receiptUuid, and deletes the
 * receipt that matches that receiptUuid
 *
 * @param {object} expense The expense around which a receipt is going to be
 *   deleted.
 * @param {object} deletedReceiptUuid The receiptUuid of the receipt that just
 *   got deleted
 * @returns Expense - returns an expense with the deleted receipt
 */

export const deleteExpenseReceipt = (
  expense = {},
  deletedReceiptUuid = null,
) => {
  const currentReceipts = R.propOr([], 'documents', expense)

  const updatedReceipts = currentReceipts.filter(
    ({ uuid }) => uuid !== deletedReceiptUuid,
  )

  return { ...expense, documents: updatedReceipts }
}
